/*!
* Modal master class popup
*/
import {initImgSwipe, updateSwipe} from '../sliders/img_swiper';

const $body = $('body');
const link = '.slide-img__link-master-class.action';
const wrapModal = '#modalMasterClass';
const title = '.slide-img__descriptions__title';
const time = '.slide-img__descriptions__time';
const description = '.modal__descriptions .modal__text';
const list = '.modal__list';
const photoId = 'masterClassInModal';
const photoSelector = 'slide-img__photo';
const photoContainer = '.swiper-container';
const photoContainerWrap = '.swiper-wrapper';
const img = '.slide-img__photo-img';
const slide = 'swiper-slide';
let $item;

/**
 * Insert photos
 * @param listPhotoModal
 */
let setPhotos = (listPhotoModal) => {
    let $modalListPhoto = $(photoContainerWrap, wrapModal);
    let itemListHtml = $modalListPhoto.html();
    let listItems = [];
    let $photoIn = $(photoContainer, wrapModal);

    if ($photoIn.hasClass(photoSelector)) {
        $.each(listPhotoModal, (i, item) => {
            $(img, $item).attr('src', item);
            listItems[i] = `<div class="${slide}">${$item.html()}</div>`;
        });

        updateSwipe(photoId, listItems.reverse());

        return;
    }

    $photoIn.addClass(photoSelector)
        .attr('id', photoId);

    $.each(listPhotoModal, (i, item) => {
        $item = $(itemListHtml).eq(0);
        $(img, $item).attr('src', item);
        listItems[i] = $item;
    });

    $modalListPhoto.html(listItems);
    initImgSwipe(wrapModal);
};

/**
 * Set list
 * @param listModal
 */
let setListItems = (listModal) => {
    let $modalList = $(list, wrapModal);
    let itemListHtml = $modalList.html();
    let listItems = [];

    $.each(listModal, (i, item) => {
        listItems[i] = $(itemListHtml).eq(0).html(item);
    });

    $modalList.html(listItems);
};

/**
 * Set modal data
 * @param data
 */
let setData = (data) => {
    $(title, wrapModal).html(data.title);
    $(time, wrapModal).html(data.time);
    $(description, wrapModal).html(data.descriptions);
    setListItems(data.list);
    setPhotos(data.photoListModal);
};

/**
 * Sets listens for events
 */
let setUpListens = () => {
    $body.on('click', link, (e) => {
        e.preventDefault();
        const dataModal = $(e.currentTarget).data('modal');
        setData(dataModal);

        $(wrapModal).foundation('open');
    });
};

/**
 * Init list
 */
let init = () => {
    if ($(link).length) {
        setUpListens();
    }
};

export {init as initMasterClass};
